import {
  APP_GET_DATA,
  APP_GET_DATA_FAILURE,
  APP_GET_DATA_SUCCESS
} from '../actions';
const initialState = {
  data: { work: [] }
};

export default (state = initialState, action) => {
  switch (action.type) {
  case APP_GET_DATA:
    return state;
  case APP_GET_DATA_SUCCESS:
    return { ...state, ...action.payload };
  case APP_GET_DATA_FAILURE:
    return;
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js